<template>
  <div>
      <div>
      <img src="../assets/img/bggrey.png" />
    <div>
      <CContainer>
        <CRow style="margin-top:-150px" class="justify-content-center">
          <CCol md="10">
            <CCardGroup>
              <CCard class="p-2">
                <CCardBody>
                  <CForm>
                    <h3 style="font-family: 'Poppins', sans-serif">
                      Registration
                    </h3>
                    <p
                      style="font-family: 'Poppins', sans-serif"
                      class="text-muted"
                    >
                      Tution Center Registration Form
                    </p>
                    <br />
                    <input placeholder="Tuition Center Name" type="text" v-model="Name"/>

                    <br />
                    <br />

                    <input placeholder="Description" type="text" v-model="Description"/>
                    <br />
                    <br />

                    <input placeholder="Phone Number" type="text" v-model="PhoneNumber"/>
                    <br />
                    <br />
                   <input placeholder="No. Of Student" type="number" v-model="Student"/>
                    <br /><br />
                    <CRow>
                      <CCol col="12" class="text-left">
                        <CButton color="primary" class="px-4" block @click="InsertRegister()"
                          >Login</CButton
                        >
                      </CCol>
                      <CCol col="6" class="text-right">
                        <CButton color="link" class="d-lg-none"
                          >Register now!</CButton
                        >
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              <CCard
                color="primary"
                text-color="white"
                class="text-center py-5 d-md-down-none"
                body-wrapper
              >
                <CCardBody>
                  <h2>Sign up</h2>
                 <img style="max-width:100%" src="../assets/img/vectortc.png" />
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
       </div>
    </div>
  </div>
</template>

<script>
import backgroundUrl from "../assets/img/bggrey.png";
export default {
  data() {
    return {
      backgroundUrl,
      options: ["Option 1", "Option 2", "Option 3"],
      Name: "",
      Description: "",
      PhoneNumber: "",
      Student: "",
    };
  },
  methods: {
         InsertRegister() {
       const formData = new FormData();
        formData.append("Name", this.Name);
        formData.append("Description", this.Description);
        formData.append("PhoneNumber", this.PhoneNumber);
        formData.append("student", this.Student);

        this.$API
          .post(this.$InsertRegistrationTuitionCenter, formData, { withCredentials: true })
          .then((response) => {
            if (response.data.status === 400) {
              this.Loading = false;
              this.Message = response.data.message;
              this.Error = true;
            }
            if (response.status == 200) {
              if (response.data.status !== 400) {
               
                  this.GoToHome();
              } else {
                this.Loading = false;
                this.Message = response.data.message;
                this.Error = true;
              }
            } else {
              this.Loading = false;
              this.Error = true;
              this.Message = response.data.message;
            }
          })
          .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
    },
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins&display=swap");

input {
  outline: 0;
  border-width: 0 0 2px;
  border-color: blue;
  width: 100%;
  font-family: "Poppins", sans-serif;
}
input:focus {
  border-color: green;
  font-family: "Poppins", sans-serif;
}
body {
  background-image: url("../assets/img/bggrey.png");
  background-repeat: repeat-x;
}
</style>
